/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Biz_UnitInputs */

const en_mk_price_biz_unit = /** @type {(inputs: Mk_Price_Biz_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/seat/month`)
};

const id_mk_price_biz_unit = /** @type {(inputs: Mk_Price_Biz_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/orang/bulan`)
};

/**
* | output |
* | --- |
* | "/seat/month" |
*
* @param {Mk_Price_Biz_UnitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_biz_unit = /** @type {((inputs?: Mk_Price_Biz_UnitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Biz_UnitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_biz_unit(inputs)
	return en_mk_price_biz_unit(inputs)
});